export const FACULTY_INFO = [
  {
    id: 'evt113_007',
    isEng: 'ENG',
    sessionTime: '08:40~09:25',
    pgTitle: 'ACC Together with KSC/KSE 1',
    pgSub: 'Myocarditis: Learning from Our Diverse Clinical Experience',
  },
  {
    id: 'evt113_008',
    isEng: 'ENG',
    sessionTime: '09:35~10:20',
    pgTitle: 'ACC Together with KSC/KSE 2',
    pgSub: 'ATTR Cardiac Amyloidosis: Not to Be Missed Any More',
  },
  {
    id: 'evt113_009',
    isEng: 'ENG',
    sessionTime: '08:40~09:25',
    pgTitle: 'ACC Together with KSC/KSHF 1',
    pgSub: 'Management of Acute Decompensated Heart Failure',
  },
  {
    id: 'evt113_010',
    isEng: 'ENG',
    sessionTime: '09:35~10:20',
    pgTitle: 'ACC Together with KSC/KSHF 2',
    pgSub: 'New Heart Failure Therapies',
  },
  { id: 'evt113_011', isEng: 'ENG', sessionTime: '08:40~09:25', pgTitle: 'ACC Together with KSC/KHRS 1', pgSub: 'Is Rate Control Dead?' },
  { id: 'evt113_012', isEng: 'ENG', sessionTime: '09:35~10:20', pgTitle: 'ACC Together with KSC/KHRS 2', pgSub: 'Sudden Death: ICDs and?' },
  {
    id: 'evt113_013',
    isEng: 'KOR',
    sessionTime: '08:40~10:20',
    pgTitle: 'Basic Research Hot Session 1',
    pgSub: 'Regeneration of Cardiac Tissue',
  },
  {
    id: 'evt113_014',
    isEng: 'KOR',
    sessionTime: '08:40~10:20',
    pgTitle: 'Women Heart Disease',
    pgSub: 'Pregnancy Associated Cardiovascular Risk',
  },
  { id: 'evt113_015', isEng: 'KOR', sessionTime: '08:40~09:25', pgTitle: 'ACHD 1', pgSub: 'Belated Diagnosis of PDA in Adult with CHD' },
  {
    id: 'evt113_016',
    isEng: 'KOR',
    sessionTime: '09:35~10:20',
    pgTitle: 'ACHD 2',
    pgSub: 'Where Are We Now in Pulmonary Valve Implantation',
  },
  {
    id: 'evt113_023',
    isEng: 'ENG',
    sessionTime: '10:30~11:15',
    pgTitle: 'ACC Together with KSC (Imaging)',
    pgSub: 'Chest Pain Guidelines from Cardiovascular Imaging Perspective',
  },
  {
    id: 'evt113_024',
    isEng: 'ENG',
    sessionTime: '11:25~12:10',
    pgTitle: 'ACC Together with KSC/KSoLA',
    pgSub: 'Optimization of Cardiovascular Risk Factors to Prevent ASCVD in Specific Populations',
  },
  { id: 'evt113_025', isEng: 'ENG', sessionTime: '10:30~11:15', pgTitle: 'ACC Together with KSC/KSIC 1', pgSub: 'Asymptomatic Severe AS' },
  {
    id: 'evt113_026',
    isEng: 'ENG',
    sessionTime: '11:25~12:10',
    pgTitle: 'ACC Together with KSC/KSIC 2',
    pgSub: 'Challenging Valvular Cases',
  },
  {
    id: 'evt113_027',
    isEng: 'ENG',
    sessionTime: '10:30~11:15',
    pgTitle: 'ACC Together with KSC/KHRS 3',
    pgSub: 'Atrial Fibrillation Ablation: Who and When?',
  },
  {
    id: 'evt113_028',
    isEng: 'ENG',
    sessionTime: '11:25~12:10',
    pgTitle: 'ACC Together with KSC (Myocardial Infarction)',
    pgSub: 'Emerging Trends in STEMI Care',
  },
  {
    id: 'evt113_029',
    isEng: 'KOR',
    sessionTime: '10:30~12:10',
    pgTitle: 'Basic Research Hot Session 2',
    pgSub: 'Current Trends of Cardiovascular Research',
  },
  {
    id: 'evt113_030',
    isEng: 'KOR',
    sessionTime: '10:30~11:15',
    pgTitle: 'Cardiogenic Shock',
    pgSub: 'Optimal Care in Patients with ECMO in Cardiogenic Shock',
  },
  {
    id: 'evt113_031',
    isEng: 'KOR',
    sessionTime: '11:25~12:10',
    pgTitle: 'Imaging',
    pgSub: 'Post-Ischemia Trial Era: Role of Cardiac Imaging',
  },
  {
    id: 'evt113_032',
    isEng: 'KOR',
    sessionTime: '10:30~11:15',
    pgTitle: 'ACHD 3',
    pgSub: 'Extracardiac Problems in ACHD: We Need More Concerns',
  },
  {
    id: 'evt113_033',
    isEng: 'KOR',
    sessionTime: '11:25~12:10',
    pgTitle: 'ACHD 4',
    pgSub: 'Long Term Prognosis of Complex Congenital Heart Disease',
  },
  {
    id: 'evt113_040',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Diamond Session [Amgen]',
    pgSub: 'LDL-C Management: From Hospitalization to Discharge in ACS Patients',
  },
  {
    id: 'evt113_041',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Diamond Session [Viatris]',
    pgSub: 'Lipitor Portfolio, Optimal Treatment for ACS Patients',
  },
  {
    id: 'evt113_042',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Scientific Session [Pfizer/BMS]',
    pgSub: 'Better Patient Care with Anticoagulation in AF and VTE',
  },
  {
    id: 'evt113_043',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Scientific Session [Boryung]',
    pgSub: 'New Insights in the Treatment of Hypertension',
  },
  {
    id: 'evt113_044',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Scientific Session [Samjin]',
    pgSub: 'Updates on Treatment Strategies for High-risk Patients',
  },
  {
    id: 'evt113_045',
    isEng: 'KOR',
    sessionTime: '12:20~13:00',
    pgTitle: 'Scientific Session [Organon]',
    pgSub: 'Early & Lower for Longer Through Intensity Statin and Ezetimibe for Lipid Management',
  },
  { id: 'evt113_052', isEng: 'KOR', sessionTime: '13:10~13:50', pgTitle: 'Memorial Lecture', pgSub: '' },
  {
    id: 'evt113_053',
    isEng: 'KOR',
    sessionTime: '13:10~13:50',
    pgTitle: 'Scientific Session [Novartis]',
    pgSub: 'ARNI: 1st Choice for below Normal LVEF Heart Failure Patients',
  },
  {
    id: 'evt113_054',
    isEng: 'KOR',
    sessionTime: '13:10~13:50',
    pgTitle: 'Scientific Session [Boehringer Ingelheim/Lilly]',
    pgSub: 'SGLT2 Inhibition in HFrEF; Digging Deeper and Treating Earlier',
  },
  {
    id: 'evt113_055',
    isEng: 'KOR',
    sessionTime: '13:10~13:50',
    pgTitle: 'Scientific Session [Bayer]',
    pgSub: 'Heart and Brain in High-Risk Vascular Disease Patients. Let`s Complete the Puzzle!',
  },
  {
    id: 'evt113_056',
    isEng: 'KOR',
    sessionTime: '13:10~13:50',
    pgTitle: 'Scientific Session [Celltrion Pharm/Dong-A ST]',
    pgSub: 'Benefits of Intensive & Consistent BP Control for Reducing CVD Risk',
  },
  {
    id: 'evt113_063',
    isEng: 'KOR',
    sessionTime: '14:00~15:40',
    pgTitle: 'Insurance Issues',
    pgSub: '3차 상대가치 조정과 시술 영역의 신설',
  },
  {
    id: 'evt113_064',
    isEng: 'KOR',
    sessionTime: '14:00~14:45',
    pgTitle: 'KSE 1',
    pgSub: 'Updates from Multicenter Research Studies in Korea',
  },
  {
    id: 'evt113_065',
    isEng: 'KOR',
    sessionTime: '14:55~15:40',
    pgTitle: 'KSE 2',
    pgSub: 'How My Research in Echocardiography Impacted My Clinical Practice',
  },
  {
    id: 'evt113_066',
    isEng: 'KOR',
    sessionTime: '14:00~15:40',
    pgTitle: 'KSIC 1',
    pgSub: 'Balancing between Ischemic Efficacy and Bleeding Risk after PCI',
  },
  { id: 'evt113_067', isEng: 'KOR', sessionTime: '14:00~14:45', pgTitle: 'KHRS 1', pgSub: "What's New in Management of AF" },
  { id: 'evt113_068', isEng: 'KOR', sessionTime: '14:55~15:40', pgTitle: 'Myocardial Infarction 1', pgSub: 'Tough Calls during AMI PCI' },
  { id: 'evt113_069', isEng: 'KOR', sessionTime: '14:00~14:45', pgTitle: 'Smart Health', pgSub: 'How to Use Wearable Devices?' },
  { id: 'evt113_070', isEng: 'KOR', sessionTime: '14:55~15:40', pgTitle: 'KSCMS', pgSub: 'Issues to Resolved in Current Lipid Management' },
  {
    id: 'evt113_071',
    isEng: 'KOR',
    sessionTime: '14:00~15:40',
    pgTitle: 'Basic Research 1',
    pgSub: 'How to Perform Good Cardiovascular Basic and Translational Research?',
  },
  {
    id: 'evt113_078',
    isEng: 'KOR',
    sessionTime: '15:50~17:30',
    pgTitle: 'Healthcare Policy',
    pgSub: '심장내과 분과전문의 수급에 대한 현안과 대책',
  },
  {
    id: 'evt113_079',
    isEng: 'KOR',
    sessionTime: '15:50~17:30',
    pgTitle: 'KSE 3',
    pgSub: 'Asymptomatic Cardiovascular Disease, What Should I Do? : Opinions from Young Tigers',
  },
  { id: 'evt113_080', isEng: 'KOR', sessionTime: '15:50~17:30', pgTitle: 'KSIC 2', pgSub: 'Updates on Bifurcation PCI' },
  {
    id: 'evt113_081',
    isEng: 'KOR',
    sessionTime: '15:50~17:30',
    pgTitle: 'Myocardial Infarction 2',
    pgSub: 'Controversial Issues for the Treatment of AMI',
  },
  {
    id: 'evt113_082',
    isEng: 'KOR',
    sessionTime: '15:50~16:35',
    pgTitle: 'Epidemiology',
    pgSub: 'CVD Epidemiology Study Using National Health Insurance Big Data',
  },
  { id: 'evt113_083', isEng: 'KOR', sessionTime: '16:45~17:30', pgTitle: 'KSoLA 1', pgSub: 'Debate: Are Big-data Studies Over-rated?' },
  {
    id: 'evt113_084',
    isEng: 'KOR',
    sessionTime: '15:50~17:30',
    pgTitle: 'Basic Research 2',
    pgSub: 'How to Make IHD and HF Model for Basic and Translational Cardiovascular Research?',
  },
  {
    id: 'evt113_085',
    isEng: 'ENG',
    sessionTime: '08:00~08:45',
    pgTitle: 'ACC Together with KSC (Education Workshop 1)',
    pgSub: 'Wide Complex Tachycardia',
  },
  {
    id: 'evt113_086',
    isEng: 'ENG',
    sessionTime: '08:55~09:40',
    pgTitle: 'ACC Together with KSC (Education Workshop 2)',
    pgSub: 'Contemporary Approaches to Stable Ischemic Heart Disease',
  },
  {
    id: 'evt113_087',
    isEng: 'ENG',
    sessionTime: '08:00~08:45',
    pgTitle: 'ACC Together with KSC/KSE 3',
    pgSub: 'The Tricuspid Valve: Forgotten No More',
  },
  {
    id: 'evt113_088',
    isEng: 'ENG',
    sessionTime: '08:55~09:40',
    pgTitle: 'ACC Together with KSC/KSE 4',
    pgSub: 'CV Imaging in Heart Failure: How and When to Use Echo, CMR and CT?',
  },
  {
    id: 'evt113_089',
    isEng: 'ENG',
    sessionTime: '08:00~08:45',
    pgTitle: 'ACC Together with KSC/KSHF 3',
    pgSub: 'Innovations in Heart Transplantation: What Does the Future Hold?',
  },
  {
    id: 'evt113_090',
    isEng: 'ENG',
    sessionTime: '08:55~09:40',
    pgTitle: 'ACC Together with KSC/KSHF 4',
    pgSub: 'HFpEF: Guidelines, Therapies, and Non-Pharmalogical Approaches',
  },
  {
    id: 'evt113_091',
    isEng: 'ENG',
    sessionTime: '08:00~08:45',
    pgTitle: 'ACC Together with KSC (Smart Health)',
    pgSub: 'Leveraging Technology for CV Prevention',
  },
  {
    id: 'evt113_092',
    isEng: 'ENG',
    sessionTime: '08:55~09:40',
    pgTitle: 'ACC Together with KSC/KSCMS',
    pgSub: 'Beyond LDL-C Lowering: Role of Non-Statin Therapies',
  },
  {
    id: 'evt113_093',
    isEng: 'KOR',
    sessionTime: '08:00~09:40',
    pgTitle: 'KSoLA 2',
    pgSub: 'Current Concepts in Pathophysiology of Atherosclerosis',
  },
  { id: 'evt113_094', isEng: 'ENG', sessionTime: '08:00~08:45', pgTitle: 'JACC Asia: Pulmonary Vascular Medicine', pgSub: '' },
  { id: 'evt113_095', isEng: 'ENG', sessionTime: '08:55~09:40', pgTitle: 'Challenging Cases', pgSub: '' },
  {
    id: 'evt113_102',
    isEng: 'ENG',
    sessionTime: '09:50~10:35',
    pgTitle: 'ACC Together with KSC (Education Workshop 3)',
    pgSub: 'Universal Definition of Heart Failure and the Impact on Your Practice',
  },
  {
    id: 'evt113_103',
    isEng: 'ENG',
    sessionTime: '10:45~11:30',
    pgTitle: 'ACC Together with KSC (Education Workshop 4)',
    pgSub: 'Latest in Valvular Heart Disease Management: 2020 ACC/AHA Valvular Heart Disease Guidelines Update',
  },
  {
    id: 'evt113_104',
    isEng: 'ENG',
    sessionTime: '09:50~10:35',
    pgTitle: 'ACC Together with KSC (Hypertension)',
    pgSub: 'Hypertension Management in Older Persons: Intensive vs. Standard Treatment',
  },
  {
    id: 'evt113_105',
    isEng: 'ENG',
    sessionTime: '10:45~11:30',
    pgTitle: 'ACC Together with KSC (Epidemiology)',
    pgSub: 'Cardiovascular Risk Assessment for Koreans: Opportunities for Improvement',
  },
  {
    id: 'evt113_106',
    isEng: 'ENG',
    sessionTime: '09:50~10:35',
    pgTitle: 'ACC Together with KSC (Cardiogenic Shock)',
    pgSub: 'Advances in Cardiogenic Shock',
  },
  {
    id: 'evt113_107',
    isEng: 'ENG',
    sessionTime: '10:45~11:30',
    pgTitle: 'ACC Together with KSC (Vascular)',
    pgSub: 'Role of Cardiac Rehabilitation for CV Prevention',
  },
  {
    id: 'evt113_108',
    isEng: 'ENG',
    sessionTime: '09:50~10:35',
    pgTitle: 'ACC Together with KSC/KHRS 4',
    pgSub: 'New Pacing Strategies: Leadless, His Bundle',
  },
  {
    id: 'evt113_109',
    isEng: 'ENG',
    sessionTime: '10:45~11:30',
    pgTitle: 'ACC Together with KSC/KHRS 5',
    pgSub: 'What Will Be New in 2025: Pulsed Field Ablation, Cardioneuroablation?',
  },
  {
    id: 'evt113_110',
    isEng: 'KOR',
    sessionTime: '09:50~11:30',
    pgTitle: 'KSoLA 3',
    pgSub: 'Secret of Development of New Drugs in Atherosclerosis',
  },
  { id: 'evt113_111', isEng: 'KOR', sessionTime: '09:50~10:35', pgTitle: 'Hypertension', pgSub: 'Obesity and Hypertension' },
  {
    id: 'evt113_112',
    isEng: 'KOR',
    sessionTime: '10:45~11:30',
    pgTitle: 'Vascular',
    pgSub: 'Vascular Health and Cardiac Rehabilitation (Endurance or High-intensity Interval Exercise?)',
  },
  {
    id: 'evt113_119',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [Viatris]',
    pgSub: 'Stepwise Treatment Options for Dyslipidemia',
  },
  {
    id: 'evt113_120',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [Amgen]',
    pgSub: 'Guideline-directed Lipid Lowering Therapy for ACS Patients',
  },
  {
    id: 'evt113_121',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [Hanmi]',
    pgSub: 'Strategies for Atherosclerosis Prevention in Dyslipidemia Patients with Hypertension',
  },
  {
    id: 'evt113_122',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [Daiichisankyo/Daewoong]',
    pgSub: 'Update on Diagnosis and Treatment of High Risk Patients of Hypertension and AF',
  },
  {
    id: 'evt113_123',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [Yuhan]',
    pgSub: 'A.I-based Wearable Electrocardiography',
  },
  {
    id: 'evt113_124',
    isEng: 'KOR',
    sessionTime: '11:40~12:20',
    pgTitle: 'Scientific Session [JW-Pharma]',
    pgSub: 'Optimal Management of Dislipidemia: Newest Evidence from Pitavastatin and Ezetimibe',
  },
  { id: 'evt113_131', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Plenary Lecture', pgSub: '' },
  { id: 'evt113_132', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Abstract 1 - Imaging', pgSub: '' },
  { id: 'evt113_133', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Abstract 2 - Heart Failure & Cardiomyopathies', pgSub: '' },
  { id: 'evt113_134', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Abstract 3 - Electrophysiology', pgSub: '' },
  { id: 'evt113_135', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Abstract 4 - Prevention and Health Promotion', pgSub: '' },
  { id: 'evt113_136', isEng: 'ENG', sessionTime: '12:30~13:15', pgTitle: 'Abstract 5 - Valvular Heart Disease', pgSub: '' },
  {
    id: 'evt113_143',
    isEng: 'ENG',
    sessionTime: '13:20~14:00',
    pgTitle: 'Abstract 6 - Interventional and Structural & Ischemic Heart Disease 1',
    pgSub: '',
  },
  {
    id: 'evt113_144',
    isEng: 'ENG',
    sessionTime: '14:10~14:50',
    pgTitle: 'Abstract 6 - Interventional and Structural & Ischemic Heart Disease 2',
    pgSub: '',
  },
  { id: 'evt113_145', isEng: 'KOR', sessionTime: '13:20~14:50', pgTitle: 'KPHS 1', pgSub: 'Inherited Cardiomyopathies' },
  { id: 'evt113_146', isEng: 'KOR', sessionTime: '13:20~14:50', pgTitle: 'Cardiac Pathology', pgSub: 'Myocarditis in COVID-19 Pandemic' },
  { id: 'evt113_147', isEng: 'KOR', sessionTime: '13:20~14:50', pgTitle: 'KHRS 2', pgSub: 'ECG Masters' },
  {
    id: 'evt113_148',
    isEng: 'KOR',
    sessionTime: '13:20~14:50',
    pgTitle: 'Cardio-Oncology',
    pgSub: 'Immunotherapy and Emerging Cardiotoxicity',
  },
  {
    id: 'evt113_149',
    isEng: 'KOR',
    sessionTime: '13:20~14:50',
    pgTitle: 'Cardiac Surgery',
    pgSub: 'Optimal Revascularization Strategy of CABG',
  },
  {
    id: 'evt113_156',
    isEng: 'KOR',
    sessionTime: '15:00~16:30',
    pgTitle: 'Education Workshop 5',
    pgSub: 'Updates in Atrial Fibrillation Diagnosis and Management',
  },
  {
    id: 'evt113_157',
    isEng: 'KOR',
    sessionTime: '15:00~16:30',
    pgTitle: 'KPHS 2',
    pgSub: 'The Fontan Physiology: More than just the Heart',
  },
  { id: 'evt113_158', isEng: 'KOR', sessionTime: '15:00~16:30', pgTitle: 'KSHF 1', pgSub: 'Essence of Recent HF Trials' },
  { id: 'evt113_159', isEng: 'KOR', sessionTime: '15:00~16:30', pgTitle: 'KHRS 3', pgSub: 'SVT & VT' },
  { id: 'evt113_160', isEng: 'KOR', sessionTime: '15:00~16:30', pgTitle: 'KSoLA 4', pgSub: 'Lifestyle Factors in COVID-19 Pandemic' },
  {
    id: 'evt113_161',
    isEng: 'KOR',
    sessionTime: '15:00~16:30',
    pgTitle: 'KSIC 3',
    pgSub: 'Basic Knowledge and Techniques for CTO Intervention',
  },
  { id: 'evt113_168', isEng: 'KOR', sessionTime: '16:40~18:10', pgTitle: 'Education Workshop 6', pgSub: 'Take a First Step for TAVR' },
  { id: 'evt113_169', isEng: 'KOR', sessionTime: '16:40~18:10', pgTitle: 'KPHS 3', pgSub: 'The Fontan: What to Do for a Better Outcome' },
  { id: 'evt113_170', isEng: 'KOR', sessionTime: '16:40~18:10', pgTitle: 'KSHF 2', pgSub: 'Debate: Hot Issues in HF Treatment' },
  { id: 'evt113_171', isEng: 'KOR', sessionTime: '16:40~18:10', pgTitle: 'KHRS 4', pgSub: 'CIED & AI' },
  { id: 'evt113_172', isEng: 'KOR', sessionTime: '16:40~18:10', pgTitle: 'KSoLA 5', pgSub: 'New Korean Lipid Guidelines Now' },
  {
    id: 'evt113_173',
    isEng: 'KOR',
    sessionTime: '16:40~18:10',
    pgTitle: 'KSIC 4',
    pgSub: 'Critical Limb Ischemia and Complex Peripheral Arterial Disease',
  },
];
